module.exports = "/_next/static/images/170576750506424263014fbd0aa1c4a6-debit-card-cut-xs.png";